exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".table-responsive[data-v-031a4b6e]{overflow-x:auto}.bg-gray[data-v-031a4b6e]{background-color:#f5f5f5!important}.label[data-v-031a4b6e]{display:inline-block;padding:2px 6px;font-size:11px;font-weight:700;line-height:1;color:#fff;text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:4px}.label-success[data-v-031a4b6e]{background-color:#5cb85c}.label-danger[data-v-031a4b6e]{background-color:#d9534f}.label-default[data-v-031a4b6e]{background-color:#999}.small-box[data-v-031a4b6e]{margin-bottom:15px}.text-right[data-v-031a4b6e]{text-align:right}.text-center[data-v-031a4b6e]{text-align:center}.text-success[data-v-031a4b6e]{color:#3c763d!important}.text-danger[data-v-031a4b6e]{color:#a94442!important}.text-muted[data-v-031a4b6e]{color:#999!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-031a4b6e","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/dashboard/growthDashboard/ShippingLineWiseGrowthComponent.vue
// module id = 1347
// module chunks = 0